<template>
  <b-row>
    <b-col cols="12" lg="12">
      <b-card no-body>
        <b-card-body>
          <b-row>
            <b-col cols="12" lg="6">
              <b-form-group label="URL Portal">
                <b-form-input
                  v-model="portal.slug"
                  v-validate="rules.portal.slug"
                  type="text"
                  class="form-control"
                  aria-describedby="invalidSlug"
                  name="slug"
                  :state="validateState('slug')"
                  data-section="portal"
                ></b-form-input>
                <b-form-invalid-feedback id="invalidSlug">
                  {{ errors.first("slug") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group label="Empresa">
                <searchable-select
                  v-model="portal.company"
                  v-validate="rules.portal.company"
                  :options="companiesOpts"
                  :placeholder="'Selecione uma empresa'"
                  :search-placeholder="'Buscar empresa...'"
                  :use-company-filter="false"
                  control-class="form-control"
                  name="company"
                  :state="validateState('company')"
                  data-section="portal"
                />
                <b-form-invalid-feedback id="invalidCompany">
                  {{ errors.first("company") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="3">
              <b-form-group label="Cor do Portal">
                <b-form-input
                  v-model="portal.color"
                  type="color"
                  class="form-control"
                  aria-describedby="invalidColor"
                  name="slug"
                  :state="validateState('color')"
                  data-section="portal"
                ></b-form-input>
                <b-form-invalid-feedback id="invalidColor">
                  {{ errors.first("color") }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="9">
              <b-form-group label="Logo">
                <template v-if="portal.logo">
                  <b-img
                    width="300"
                    height="300"
                    thumbnail
                    fluid
                    :src="`https://${portalBucket}/${portal._id}/${portal.logo}`"
                    crossorigin="anonymous"
                    alt="Logo"
                  />
                  <b-button
                    class="mt-4 px-4"
                    :disabled="loading"
                    @click="portal.logo = false"
                    >Trocar</b-button
                  >
                </template>
                <template v-else>
                  <b-img
                    v-if="files.logo.file"
                    width="300"
                    height="300"
                    thumbnail
                    fluid
                    :src="fileToImage(files.logo.file)"
                    alt="Logo"
                  />
                  <b-form-file
                    v-model="files.logo.file"
                    v-validate="rules.portal.logo"
                    placeholder="Selecione uma imagem."
                    name="logo"
                    aria-describedby="invalidLogo"
                    :state="validateState('logo')"
                    data-section="portal"
                  ></b-form-file>
                  <b-form-invalid-feedback id="invalidLogo">
                    {{ errors.first("logo") }}
                  </b-form-invalid-feedback>
                </template>
              </b-form-group>
            </b-col>
          </b-row>
          <b-card header="Idiomas">
            <b-row>
              <b-col cols="6">
                <b-form-select
                  v-model="selectedLanguage"
                  :options="languageOptions"
                ></b-form-select>
              </b-col>
              <b-col cols="6">
                <b-form-checkbox
                  v-model="portal.languages[selectedLanguage].enabled"
                  switch
                >
                  Habilitado
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-form novalidate>
              <hr class="hr-text" data-content="Home" />
              <b-row>
                <b-col cols="12" lg="6">
                  <b-form-group label="Título">
                    <b-form-input
                      v-model="portal.languages[selectedLanguage].title"
                      type="text"
                      class="form-control"
                      aria-describedby="invalidTitle"
                      name="title"
                      :state="validateState('title')"
                      data-section="portal"
                    ></b-form-input>
                    <b-form-invalid-feedback id="invalidTitle">
                      {{ errors.first("title") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="6">
                  <b-form-group label="Texto de apresentação">
                    <b-form-textarea
                      v-model="
                        portal.languages[selectedLanguage].introductionText
                      "
                      class="form-control"
                      aria-describedby="invalidIntroductionText"
                      name="introductionText"
                      :rows="3"
                      :state="validateState('introductionText')"
                      data-section="portal"
                    ></b-form-textarea>
                    <b-form-invalid-feedback id="invalidIntroductionText">
                      {{ errors.first("introductionText") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="6">
                  <b-form-group label="Texto de instrução">
                    <b-form-textarea
                      v-model="
                        portal.languages[selectedLanguage].instructionText
                      "
                      class="form-control"
                      aria-describedby="invalidInstructionText"
                      name="instructionText"
                      :rows="3"
                      :state="validateState('instructionText')"
                      data-section="portal"
                    ></b-form-textarea>
                    <b-form-invalid-feedback id="invalidInstructionText">
                      {{ errors.first("instructionText") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="6">
                  <b-form-group label="Texto telefone">
                    <b-form-textarea
                      v-model="
                        portal.languages[selectedLanguage].phoneServiceText
                      "
                      class="form-control"
                      aria-describedby="invalidPhoneServiceText"
                      name="phoneServiceText"
                      :rows="3"
                      :state="validateState('phoneServiceText')"
                      data-section="portal"
                    ></b-form-textarea>
                    <b-form-invalid-feedback id="invalidPhoneServiceText">
                      {{ errors.first("phoneServiceText") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr class="hr-text" data-content="Denunciar" />
              <b-row>
                <b-col cols="12" lg="6">
                  <b-form-group label="Título">
                    <b-form-input
                      v-model="
                        portal.languages[selectedLanguage].complaint.title
                      "
                      type="text"
                      class="form-control"
                      aria-describedby="invalidComplaintTitle"
                      name="complaintTitle"
                      :state="validateState('complaintTitle')"
                      data-section="portal"
                    ></b-form-input>
                    <b-form-invalid-feedback id="invalidComplaintTitle">
                      {{ errors.first("complaintTitle") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" lg="6">
                  <b-form-group label="Texto de apresentação">
                    <b-form-textarea
                      v-model="
                        portal.languages[selectedLanguage].complaint
                          .introductionText
                      "
                      class="form-control"
                      aria-describedby="invalidComplaintIntroductionText"
                      name="complaintIntroductionText"
                      :rows="3"
                      :state="validateState('complaintIntroductionText')"
                      data-section="portal"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                      id="invalidComplaintIntroductionText"
                    >
                      {{ errors.first("complaintIntroductionText") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="6">
                  <b-form-group label="Texto de instrução">
                    <b-form-textarea
                      v-model="
                        portal.languages[selectedLanguage].complaint
                          .instructionText
                      "
                      class="form-control"
                      aria-describedby="invalidComplaintInstructionText"
                      name="complaintInstructionText"
                      :rows="3"
                      :state="validateState('complaintInstructionText')"
                      data-section="portal"
                    ></b-form-textarea>
                    <b-form-invalid-feedback
                      id="invalidComplaintInstructionText"
                    >
                      {{ errors.first("complaintInstructionText") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-card-body>
        <b-card-footer>
          <span v-if="upload.visible">Enviando {{ upload.filename }}...</span>
          <b-progress
            v-if="upload.visible"
            class="mb-2"
            :value="upload.value"
            :max="100"
            show-progress
          ></b-progress>
          <b-button
            variant="primary"
            class="px-4"
            :disabled="loading"
            @click="onSaveClicked"
            >Salvar</b-button
          >
        </b-card-footer>
      </b-card>
    </b-col>
    <a
      ref="download"
      class="invisible"
      target="_blank"
      :download="download.name"
      :href="download.link"
    ></a>
  </b-row>
</template>

<script>
import {
  createPortal,
  editPortal,
  getPortal,
  sendPortalFile,
} from "@/api/portal";
import { ValidatorDictionary } from "@/i18n";

import { mapGetters } from "vuex";

import { mask } from "vue-the-mask";
import { mergeDeep } from "@/utils/commons";
import { getCompanies } from "../../api/company";
import SearchableSelect from "@/components/SearchableSelect.vue";

const langProps = {
  enabled: false,
  title: null,
  introductionText: null,
  instructionText: null,
  phoneServiceText: null,
  complaint: {
    title: null,
    introductionText: null,
    instructionText: null,
  },
};

export default {
  name: "PortalManager",
  components: {
    SearchableSelect,
  },
  directives: { mask },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      i18n: ValidatorDictionary.attributes,
      companies: [],
      download: {
        name: null,
        link: null,
      },
      rules: {
        portal: {
          slug: { required: true, "slug-availability": { id: this.id } },
          company: { required: true },
        },
      },
      loading: false,
      selectedLanguage: "pt",
      languageOptions: [
        { value: "pt", text: "Português" },
        { value: "en", text: "Inglês" },
        { value: "es", text: "Espanhol" },
      ],

      portal: {
        color: "#AAAAAA",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        languages: {
          pt: mergeDeep({}, langProps),
          en: mergeDeep({}, langProps),
          es: mergeDeep({}, langProps),
        },
      },
      files: {
        logo: {
          name: ValidatorDictionary.attributes.logo,
          file: null,
          type: "logo",
          current: null,
        },
      },
      editing: false,
      upload: {
        value: 0,
        visible: false,
        filename: "",
      },
    };
  },
  computed: {
    ...mapGetters(["profile", "portalBucket"]),
    companiesOpts() {
      const opts = [];
      opts.push({ value: null, text: "" });
      for (const company of this.companies) {
        opts.push({ value: company._id, text: company.fantasyName });
      }
      return opts;
    },
    isEditing() {
      return this.id !== "novo";
    },
  },
  async created() {
    await this.loadCompanies();

    let portal;

    if (this.id !== "novo") {
      const response = await getPortal(this.id);
      portal = response.data;
    }

    portal = portal || {
      color: "#AAAAAA",
      fontColor: "#000000",
      backgroundColor: "#FFFFFF",
      languages: {},
    };

    portal.languages.pt = portal.languages.pt || mergeDeep({}, langProps);
    portal.languages.pt.complaint =
      portal.languages.pt.complaint || mergeDeep({}, langProps.complaint);

    portal.languages.en = portal.languages.en || mergeDeep({}, langProps);
    portal.languages.en.complaint =
      portal.languages.en.complaint || mergeDeep({}, langProps.complaint);

    portal.languages.es = portal.languages.es || mergeDeep({}, langProps);
    portal.languages.es.complaint =
      portal.languages.es.complaint || mergeDeep({}, langProps.complaint);

    this.portal = portal;
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    async loadCompanies() {
      const response = await getCompanies();
      this.companies = response.data;
    },
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    fileToImage(file) {
      return URL.createObjectURL(file);
    },

    async onSaveClicked() {
      const filesToCheck = Object.values(this.files);
      const filesToUpload = [];
      let totalSize = 0;

      for (const item of filesToCheck) {
        if (item.file) {
          filesToUpload.push(item);
          totalSize += item.file.size;
        }
      }

      const validated = await this.validateFields();
      if (!validated) return;

      const payload = JSON.parse(JSON.stringify(this.portal));

      this.loading = true;

      if (this.isEditing) {
        await editPortal(payload);
      } else {
        const { _id } = (await createPortal(payload)).data;
        this.portal._id = _id;
      }

      let loaded = 0;
      this.upload.visible = true;
      for (const item of filesToUpload) {
        this.upload.filename = item.name;
        await sendPortalFile(this.portal, item, (evt) => {
          this.upload.value = ((loaded + evt.loaded) / totalSize) * 100;
        });
        loaded += item.file.size;
      }
      this.upload.visible = false;

      this.loading = false;
      this.$bvToast.toast(
        `Portal ${this.isEditing ? "editado" : "criado"} com sucesso!`,
        {
          title: "Sucesso",
          toastClass: "custom-toast custom-toast-success",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
          noCloseButton: false,
        }
      );
      this.$router.go(-1);
    },

    async validateFields() {
      return await this.$validator.validateAll();
    },
  },
};
</script>
